import { render, staticRenderFns } from "./LiveAccountTab.vue?vue&type=template&id=a8ae56f2"
import script from "./LiveAccountTab.vue?vue&type=script&lang=js"
export * from "./LiveAccountTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports